import { render, staticRenderFns } from "./CustomerCardsTable.vue?vue&type=template&id=20b8bf30&scoped=true"
import script from "./CustomerCardsTable.vue?vue&type=script&lang=ts"
export * from "./CustomerCardsTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCardsTable.vue?vue&type=style&index=0&id=20b8bf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8bf30",
  null
  
)

export default component.exports